import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_243: DocMigration = {
  maxSchemaVersion: "0.0.243",
  description: "Adds a measurements table to the doc",
  apply(json: any) {
    if (!json.measurements) {
      json.measurements = {};
    }
    return json;
  },
};

export default migration_0_0_243;
